import { useState, useEffect } from 'react';
import API from 'utils/API';

type useFetchTypes = {
  method: 'get' | 'post' | 'put' | 'patch' | 'delete' | 'options';
  url: string;
  data?: string;
  config?: string;
};

const useFetch = ({ method, url, data, config }: useFetchTypes) => {
  const [response, setResponse] = useState<any>([]);
  const [error, setError] = useState({ error: false, body: '' });
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      API({ url, method, data })
        .then((response: { data: any }): any => {
          setResponse(response.data);
        })
        .finally(() => {
          setIsLoading(false);
        })
        .catch((error) => {
          let errorInfo: string;
          if (error.response) {
            errorInfo = `${error.response.status}: ${error.response.data}`;
          } else if (error.request) {
            errorInfo = error.request;
          } else {
            errorInfo = error.message;
          }
          setError((prevError) => {
            return { ...prevError, error: true, body: errorInfo };
          });
        });
    };

    fetchData();
  }, [method, url, data, config]);

  return { response, error, isLoading };
};

export default useFetch;
